import api from "./ApiUrl";

const url = "report/v1/api";

export const getPlayerSubscriptionReport = async () => {
  const res = await api.get(`${url}/admin/report/subscription`);
  return res.data;
};

export const getPlayerSessionReport = async () => {
  const res = await api.get(`${url}/admin/report/session`);
  return res.data;
};

export const getAgeCategoryReport = async () => {
  const res = await api.get(`${url}/public/age/category`);
  return res.data;
};

export const getGenderReport = async () => {
  const res = await api.get(`${url}/public/gender`);
  return res.data;
};

export const getStatusReport = async () => {
  const res = await api.get(`${url}/public/enabled/status`);
  return res.data;
};

export const getPublicPaymentStatusReport = async () => {
  const res = await api.get(`${url}/public/paymentStatus`);
  return res.data;
};

export const getPaymentModeReport = async () => {
  const res = await api.get(`${url}/public/paymentType`);
  return res.data;
};

export const getPackageTypeReport = async () => {
  const res = await api.get(`${url}/public/package-type`);
  return res.data;
};

export const getExpenseTypeReport = async () => {
  const res = await api.get(`${url}/public/expensive/type`);
  return res.data;
};

export const getOverdueRangeReport = async () => {
  const res = await api.get(`${url}/public/overdue/range`);
  return res.data;
};

export const getCoachReport = async (
  page,
  size,
  search,
  selectedSession,
  selectedSkills,
  selectedStatus,
  selectedPlayer,
  startDate,
  endDate,
) => {
  const params = { page, size };

  if (search) {
    params.search = search;
  }
  if (selectedSession) {
    params.sessionId = selectedSession;
  }
  if (selectedSkills) {
    params.skills = selectedSkills;
  }
  if (selectedStatus) {
    params.status = selectedStatus;
  }
  if (selectedPlayer) {
    params.playerId = selectedPlayer;
  }
  if (startDate) {
    params.fromDate = startDate;
  }
  if (endDate) {
    params.toDate = endDate;
  }

  const res = await api.get(`${url}/admin/report/coach`, { params });
  return res.data;
};

export const getCoachFeedbackReport = async (
  page,
  size,
  search,
  selectedRating,
  selectedStatus,
  startDate,
  endDate,
) => {
  const params = { page, size };

  if (search) {
    params.search = search;
  }
  if (selectedRating) {
    params.ratingFilter = selectedRating;
  }
  if (selectedStatus) {
    params.approvedStatus = selectedStatus;
  }
  if (startDate) {
    params.fromDate = startDate;
  }
  if (endDate) {
    params.toDate = endDate;
  }
  const res = await api.get(`${url}/admin/report/coach/feedback`, { params });
  return res.data;
};

export const getCoachAttendanceReport = async (
  page,
  size,
  search,
  session,
  startDate,
  endDate,
) => {
  const params = { page, size };
  if (session) {
    params.sessionId = session;
  }
  if (startDate) {
    params.fromDate = startDate;
  }
  if (endDate) {
    params.toDate = endDate;
  }

  if (search) {
    params.search = search;
  }
  const res = await api.get(`${url}/admin/report/coach/attendence`, { params });
  return res.data;
};

export const getCashBookReport = async (
  page,
  size,
  search,
  paymentMode,
  expensiveType,
  startDate,
  endDate,
) => {
  const params = { page, size };
  if (paymentMode) {
    params.paymentMode = paymentMode;
  }
  if (expensiveType) {
    params.expensiveType = expensiveType;
  }
  if (startDate) {
    params.fromDate = startDate;
  }
  if (endDate) {
    params.toDate = endDate;
  }

  if (search) {
    params.search = search;
  }
  const res = await api.get(`${url}/admin/report/cashbook`, { params });
  return res.data;
};

export const getEnquiryPlayerReport = async (
  page,
  size,
  search,
  startDate,
  endDate,
) => {
  const params = { page, size };

  if (search) {
    params.search = search;
  }
  if (startDate) {
    params.fromDate = startDate;
  }
  if (endDate) {
    params.toDate = endDate;
  }
  const res = await api.get(`${url}/admin/report/enquiry/player`, { params });
  return res.data;
};

export const getPlayerAttendanceReport = async (
  page,
  size,
  search,
  selectedSession,
  selectedPlayer,
  startDate,
  endDate,
) => {
  const params = { page, size };
  if (search) {
    params.search = search;
  }
  if (selectedSession) {
    params.sessionId = selectedSession;
  }
  if (startDate) {
    params.fromDate = startDate;
  }
  if (endDate) {
    params.toDate = endDate;
  }

  if (selectedPlayer) {
    params.playerId = selectedPlayer;
  }
  const res = await api.get(`${url}/admin/report/player/attendance`, {
    params,
  });
  return res.data;
};

export const getPlayerFeedbackReport = async (
  page,
  size,
  search,
  selectedStatus,
  selectedRating,
  startDate,
  endDate,
) => {
  const params = { page, size };
  if (selectedStatus) {
    params.approvedStatus = selectedStatus;
  }
  if (selectedRating) {
    params.ratingFilter = selectedRating;
  }
  if (startDate) {
    params.fromDate = startDate;
  }
  if (endDate) {
    params.toDate = endDate;
  }

  if (search) {
    params.search = search;
  }
  const res = await api.get(`${url}/admin/report/player/feedback`, { params });
  return res.data;
};

export const getPlayerPaymentHistoryReport = async (
  page,
  size,
  search,
  playerId,
  packageId,
  paymentMode,
  startDate,
  endDate,
) => {
  const params = { page, size };
  if (playerId) {
    params.playerId = playerId;
  }
  if (packageId) {
    params.packageId = packageId;
  }
  if (paymentMode) {
    params.paymentMode = paymentMode;
  }
  if (startDate) {
    params.fromDate = startDate;
  }
  if (endDate) {
    params.toDate = endDate;
  }

  if (search) {
    params.search = search;
  }
  const res = await api.get(`${url}/admin/report/player/payment/history`, {
    params,
  });
  return res.data;
};

export const getPlayerReport = async (
  page,
  size,
  search,
  playerCategoryId,
  gender,
  paymentStatus,
  status,
  packageId,
  coachId,
  paymentMode,
  startDate,
  endDate,
) => {
  const params = { page, size };
  if (playerCategoryId) {
    params.ageCategory = playerCategoryId;
  }
  if (packageId) {
    params.packageId = packageId;
  }
  if (coachId) {
    params.coachId = coachId;
  }
  if (gender) {
    params.gender = gender;
  }
  if (paymentStatus) {
    params.paymentStatus = paymentStatus;
  }
  if (status) {
    params.status = status;
  }
  if (paymentMode) {
    params.paymentMode = paymentMode;
  }
  if (startDate) {
    params.fromDate = startDate;
  }
  if (endDate) {
    params.toDate = endDate;
  }

  if (search) {
    params.search = search;
  }
  const res = await api.get(`${url}/admin/report/player`, {
    params,
  });
  return res.data;
};

export const getPlayerRegisterReport = async (
  page,
  size,
  search,
  ageCategory,
  gender,
  status,
  startDate,
  endDate,
) => {
  const params = { page, size };
  if (ageCategory) {
    params.ageCategory = ageCategory;
  }
  if (gender) {
    params.gender = gender;
  }
  if (status) {
    params.status = status;
  }
  if (startDate) {
    params.fromDate = startDate;
  }
  if (endDate) {
    params.toDate = endDate;
  }

  if (search) {
    params.search = search;
  }
  const res = await api.get(`${url}/admin/report/registration/player`, {
    params,
  });
  return res.data;
};

export const getSubscriptionReport = async (
  page,
  size,
  search,
  selectedStatus,
) => {
  const params = { page, size };
  if (selectedStatus) {
    params.status = selectedStatus;
  }

  if (search) {
    params.search = search;
  }

  const res = await api.get(`${url}/admin/report/search/subscription`, {
    params,
  });
  return res.data;
};

export const getSessionReport = async (page, size, search, selectedStatus) => {
  const params = { page, size };
  if (selectedStatus) {
    params.status = selectedStatus;
  }

  if (search) {
    params.search = search;
  }
  const res = await api.get(`${url}/admin/report/session/search`, {
    params,
  });
  return res.data;
};

export const getUpcomingRenewalsReport = async (
  page,
  size,
  search,
  selectedPackage,
  selectedPlayer,
  status,
  fromDate,
  toDate,
) => {
  const params = { page, size };
  if (status) {
    params.status = status;
  }
  if (fromDate) {
    params.fromDate = fromDate;
  }
  if (toDate) {
    params.toDate = toDate;
  }
  if (selectedPackage) {
    params.packageId = selectedPackage;
  }
  if (selectedPlayer) {
    params.playerId = selectedPlayer;
  }

  if (search) {
    params.search = search;
  }
  const res = await api.get(`${url}/admin/report/upcoming-renewals`, {
    params,
  });
  return res.data;
};

export const getReminderSendReport = async (
  page,
  size,
  search,
  startDate,
  endDate,
) => {
  const params = { page, size };

  if (startDate) {
    params.fromDate = startDate;
  }
  if (endDate) {
    params.toDate = endDate;
  }

  if (search) {
    params.search = search;
  }
  const res = await api.get(`${url}/admin/report/reminder/send`, {
    params,
  });
  return res.data;
};

export const getOverDueReport = async (
  page,
  size,
  search,
  playerId,
  packageId,
  selectedOverdueRange,
  startDate,
  endDate,
) => {
  const params = { page, size };
  if (playerId) {
    params.playerId = playerId;
  }
  if (packageId) {
    params.packageId = packageId;
  }
  if (selectedOverdueRange) {
    params.range = selectedOverdueRange;
  }
  if (startDate) {
    params.fromDate = startDate;
  }
  if (endDate) {
    params.toDate = endDate;
  }

  if (search) {
    params.search = search;
  }
  const res = await api.get(`${url}/admin/report/over/due`, {
    params,
  });
  return res.data;
};

export const getPackagePurchaseReport = async (
  page,
  size,
  search,
  selectedPackage,
  selectedPlayer,
  startDate,
  endDate,
) => {
  const params = { page, size };

  if (search) {
    params.search = search;
  }
  if (selectedPackage) {
    params.packageId = selectedPackage;
  }
  if (selectedPlayer) {
    params.playerId = selectedPlayer;
  }
  // if (selectedPaymentStatus) {
  //   params.paymentStatus = selectedPaymentStatus;
  // }

  if (startDate) {
    params.fromDate = startDate;
  }

  if (endDate) {
    params.toDate = endDate;
  }

  const res = await api.get(`${url}/admin/report/package/purchase`, {
    params,
  });
  return res.data;
};

//super admin 

export const getPaymentHistroyReport = async (
  page,
  size,
  search,
  tenantId,
  paymentMode,
  paymentType,
  startDate,
  endDate,
) => {
  const params = { page, size };

  if (search) {
    params.search = search;
  }
  if (tenantId) {
    params.tenantId = tenantId;
  }
  if (paymentMode) {
    params.paymentMode = paymentMode;
  }
  if (paymentType) {
    params.paymentType = paymentType;
  }
  if (startDate) {
    params.fromDate = startDate;
  }
  if (endDate) {
    params.toDate = endDate;
  }
  const res = await api.get(`${url}/super/report/tenant/payment/history`, {
    params,
  });
  return res.data;
};

export const getReportForUsers = async (
  page,
  size,
  search,
  tenantId,
  status,
) => {
  const params = { page, size };
  if (tenantId) {
    params.tenantId = tenantId;
  }
  if (status) {
    params.status = status;
  }

  if (search) {
    params.search = search;
  }
  const res = await api.get(`${url}/super/report/users`, {
    params,
  });
  return res.data;
};

export const getRegisterTenantReport = async (
  page,
  size,
  search,
  selectedStatus,
  startDate,
  endDate,
) => {
  const params = { page, size };

  if (search) {
    params.search = search;
  }
  if (selectedStatus) {
    params.active = selectedStatus;
  }
  if (startDate) {
    params.fromDate = startDate;
  }
  if (endDate) {
    params.toDate = endDate;
  }
  const res = await api.get(`${url}/super/report/Registered/tenant`, {
    params,
  });
  return res.data;
};

export const getTenantReport = async (
  page,
  size,
  search,
  startDate,
  endDate,
  selectedStatus
) => {
  const params = { page, size };

  if (search) {
    params.search = search;
  }
  if (startDate) {
    params.fromDate = startDate;
  }
  if (endDate) {
    params.toDate = endDate;
  }
  if (selectedStatus) {
    params.status = selectedStatus;
  }
  const res = await api.get(`${url}/super/report/active/tenant`, {
    params,
  });
  return res.data;
};

export const getTenantEmailReport = async (
  page,
  size,
  search,
  startDate,
  endDate,
  selectedStatus
) => {
  const params = { page, size };

  if (search) {
    params.search = search;
  }
  if (startDate) {
    params.fromDate = startDate;
  }
  if (endDate) {
    params.toDate = endDate;
  }
  if (selectedStatus) {
    params.send = selectedStatus;
  }
  const res = await api.get(`${url}/super/report/email/tenant`, {
    params,
  });
  return res.data;
};


//coach reporrts 

export const getCoachSessionReport = async (page, size, search, selectedStatus) => {
  const params = { page, size };
  if (selectedStatus) {
    params.status = selectedStatus;
  }

  if (search) {
    params.search = search;
  }
  const res = await api.get(`${url}/coach/report/session`, {
    params,
  });
  return res.data;
};

export const getCoachPlayerAttendanceReport = async (
  page,
  size,
  search,
  selectedSession,
  // selectedPlayer,
  startDate,
  endDate,
) => {
  const params = { page, size };
  if (search) {
    params.search = search;
  }
  if (selectedSession) {
    params.sessionId = selectedSession;
  }
  if (startDate) {
    params.fromDate = startDate;
  }
  if (endDate) {
    params.toDate = endDate;
  }
  const res = await api.get(`${url}/coach/report/player/attendance`, {
    params,
  });
  return res.data;
};

export const getCoachFeedbackReportByCoachlogin = async (
  page,
  size,
  search,
  selectedRating,
  // selectedStatus,
  startDate,
  endDate,
) => {
  const params = { page, size };

  if (search) {
    params.search = search;
  }
  if (selectedRating) {
    params.ratingFilter = selectedRating;
  }
  // if (selectedStatus) {
  //   params.approvedStatus = selectedStatus;
  // }
  if (startDate) {
    params.fromDate = startDate;
  }
  if (endDate) {
    params.toDate = endDate;
  }
  const res = await api.get(`${url}/coach/report/feedback`, { params });
  return res.data;
};

export const getCoachAttendanceReportByLogin = async (
  page,
  size,
  search,
  session,
  startDate,
  endDate,
) => {
  const params = { page, size };
  if (session) {
    params.sessionId = session;
  }
  if (startDate) {
    params.fromDate = startDate;
  }
  if (endDate) {
    params.toDate = endDate;
  }

  if (search) {
    params.search = search;
  }
  const res = await api.get(`${url}/coach/report/attendance`, { params });
  return res.data;
};

export const getAssignedPlayerReportByCoachLogin = async (
  page,
  size,
  search,
  // playerCategoryId,
  gender,
  // paymentStatus,
  // status,
  packageId,
  // coachId,
  // paymentMode,
  // startDate,
  // endDate,
) => {
  const params = { page, size };
  // if (playerCategoryId) {
  //   params.ageCategory = playerCategoryId;
  // }
  if (packageId) {
    params.packageId = packageId;
  }
  // if (coachId) {
  //   params.coachId = coachId;
  // }
  if (gender) {
    params.gender = gender;
  }
  // if (paymentStatus) {
  //   params.paymentStatus = paymentStatus;
  // }
  // if (status) {
  //   params.status = status;
  // }
  // if (paymentMode) {
  //   params.paymentMode = paymentMode;
  // }
  // if (startDate) {
  //   params.fromDate = startDate;
  // }
  // if (endDate) {
  //   params.toDate = endDate;
  // }

  if (search) {
    params.search = search;
  }
  const res = await api.get(`${url}/coach/report/assigned/players`, {
    params,
  });
  return res.data;
};

